import find from './lodash/find';
export default find;